import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Col, Empty, Image, Row, Spin, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { API_BASE } from "../config/api";

export default function Catalog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [failedImages, setFailedImages] = useState({});
  const [previewIndex, setPreviewIndex] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const load = useCallback(async (signal) => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${API_BASE}/public-images`, { signal, cache: "no-store" });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "No pudimos cargar el catálogo.");
      if (!signal?.aborted) { setItems(Array.isArray(data) ? data : []); setFailedImages({}); }
    } catch (requestError) {
      if (requestError.name !== "AbortError") setError("No pudimos cargar el catálogo. Intentá nuevamente.");
    } finally { if (!signal?.aborted) setLoading(false); }
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    load(controller.signal);
    return () => controller.abort();
  }, [load]);

  return (
    <>
      <Navbar />
      <main style={{ minHeight: "70vh", padding: "64px 20px", background: "linear-gradient(180deg, #fff, #fcf8f0)" }}>
        <div style={{ maxWidth: 1180, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 36 }}>
            <Typography.Text style={{ color: "#8a6d3b", fontSize: 11, fontWeight: 800, letterSpacing: 2 }}>ESTUDIO ISAAC</Typography.Text>
            <Typography.Title level={1} style={{ color: "#30291e", fontSize: "clamp(30px, 6vw, 44px)", margin: "12px 0" }}>Nuestro catálogo</Typography.Title>
            <Typography.Paragraph style={{ color: "#867b68", fontSize: 15 }}>Conocé nuestros servicios, precios y novedades. Tocá cualquier imagen para ampliarla.</Typography.Paragraph>
          </div>
          {loading ? <div style={{ padding: 60, textAlign: "center" }}><Spin size="large" /></div> : error ? (
            <Alert type="warning" showIcon message={error} action={<Button onClick={() => load()}>Reintentar</Button>} />
          ) : !items.length ? (
            <Empty description="Pronto vas a encontrar nuestro catálogo aquí." />
          ) : (
            <Image.PreviewGroup
              styles={{ popup: { mask: { backgroundColor: "rgba(0, 0, 0, 0.82)" } } }}
              items={items.map((item) => ({ src: item.imageUrl, alt: item.title }))}
              preview={{
                zIndex: 1600,
                closeIcon: (
                  <span style={{ display: "grid", placeItems: "center", width: 40, height: 40, borderRadius: "50%", backgroundColor: "#fff", color: "#30291e", boxShadow: "0 2px 12px rgba(0,0,0,0.3)" }}>
                    <CloseOutlined style={{ fontSize: 22 }} />
                  </span>
                ),
                open: previewOpen,
                current: previewIndex,
                onOpenChange: setPreviewOpen,
                onChange: setPreviewIndex,
              }}
            >
              <Row gutter={[24, 24]}>
                {items.map((item, index) => (
                  <Col xs={24} sm={12} lg={8} key={item.id}>
                    <button
                      type="button"
                      aria-label={`Ampliar ${item.title}`}
                      onClick={() => { setPreviewIndex(index); setPreviewOpen(true); }}
                      style={{ display: "block", width: "100%", padding: 0, border: 0, borderRadius: 12, background: "transparent", cursor: "zoom-in", boxShadow: "0 8px 28px rgba(80,61,29,0.08)", overflow: "hidden" }}
                    >
                      <Image src={item.imageUrl} alt={item.title} width="100%" style={{ height: "auto", display: "block" }} preview={false} onError={() => setFailedImages((current) => ({ ...current, [item.id]: true }))} />
                    </button>
                      {failedImages[item.id] && <Typography.Paragraph type="secondary" style={{ marginTop: 12 }}>No pudimos mostrar esta imagen. Intentá recargar la página.</Typography.Paragraph>}
                  </Col>
                ))}
              </Row>
            </Image.PreviewGroup>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}
